module.exports = __webpack_public_path__ + "img/security-audit-img-1.579f433d.jpeg";